const videoWrapper = document.getElementById('videoWrapper');

import {
  no_scroll,
  return_scroll
} from '../common/_common';

export function keyVisualMovie() {
  if (videoWrapper != null) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    const play = document.getElementById('play');
    const close = document.getElementById('close');
    const videoCover = document.getElementById('cover');
    const videoWrapper = document.getElementById('videoWrapper');
    const bgVideo = document.getElementById('bgVideo');
    const bgVideoId = bgVideo.getAttribute('data-url');
    const playVideoId = document.getElementById('playVideo').getAttribute('data-url');
    let ytPlayer1, ytPlayer2;

    window.onYouTubeIframeAPIReady = function () {
      ytPlayer1 = new YT.Player('bgVideo', {
        videoId: bgVideoId,
        playerVars: {
          rel: 0,
          controls: 0,
          showinfo: 0,
          modestbranding: 1,
          iv_load_policy: 3,
          playsinline: 1,
          wmode: 'transparent',
          fs: 0,
          disablekb: 1,
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange1
        }
      });
      ytPlayer2 = new YT.Player('playVideo', {
        videoId: playVideoId,
        playerVars: {
          rel: 0,
          controls: 1,
          showinfo: 0,
          modestbranding: 1,
          iv_load_policy: 3,
          wmode: 'transparent'
        },
        events: {
          'onStateChange': onPlayerStateChange2
        }
      });
    }

    function onPlayerReady(event) {
      ytPlayer1.mute();
      ytPlayer1.playVideo();
    }

    function onPlayerStateChange1(event) {
      var ytStatus = event.target.getPlayerState();
      if (ytStatus == YT.PlayerState.ENDED) {
        ytPlayer1.mute();
        ytPlayer1.seekTo(0, true);
        ytPlayer1.playVideo();
      }
      if (ytStatus == YT.PlayerState.BUFFERING) {
        ytPlayer1.mute();
        ytPlayer1.seekTo(0.1, true);
        ytPlayer1.playVideo();
      }
    }

    function onPlayerStateChange2(event) {
      var ytStatus = event.target.getPlayerState();
      if (ytStatus == YT.PlayerState.ENDED) {
        videoWrapper.classList.remove('isPlay');
        ytPlayer2.stopVideo();
      }
    }

    function playVideo() {
      if (videoWrapper.classList.contains('isPlay')) {
        return_scroll();
        videoWrapper.classList.remove('isPlay');
        ytPlayer2.stopVideo();
        ytPlayer1.mute();
        ytPlayer1.playVideo();
      } else {
        no_scroll();
        videoWrapper.classList.add('isPlay');
        ytPlayer2.playVideo();
      }
    }

    videoCover.addEventListener('click', playVideo, false);
    play.addEventListener('click', playVideo, false);
    close.addEventListener('click', playVideo, false);

    videoWrapper.addEventListener("mouseover", () => {
      videoWrapper.classList.add('isDark');
    });

    videoWrapper.addEventListener("mouseleave", () => {
      videoWrapper.classList.remove('isDark');
    });
  }
}
